export default {
  schema: {
    title: 'Screen Name',
    type: 'object',
    required: ['org'],
    properties: {
      org: {
        title: 'Organization',
        type: 'string'
      },
      positions: {
        title: 'Positions',
        type: 'array',
        minItems: 2,
        items: {
          type: 'object',
          required: ['position'],
          properties: {
            id: {
              type: 'string'
            },
            position: {
              title: 'Position',
              type: 'string'
            }
          }
        }
      }
    }
  },
  uiSchema: {
    group_pastEmployment: {
      'ui:title': {
        text: '<b>Past Employment</b>',
        escape: false
      }
    },
    org: {
      'ui:widget': 'text'
    },
    positions: {
      'ui:options': {
        itemName: 'Position',
        orderable: true
      },
      items: {
        position: {
          'ui:widget': 'text'
        },
        'dm:layout': [{
          id: 'position',
          type: 'field'
        }]
      }
    },
    'dm:layout': [{
      id: 'group_pastEmployment',
      type: 'group',
      children: [{
        id: 'org',
        type: 'field'
      }, {
        id: 'positions',
        type: 'array'
      }]
    }]
  },
  formData: {}
};